const en = {
  nav: { home: "Home", book: "Book now", faq: "FAQ", contact: "Contact", admin: "Admin", about: "About", track: "Track" },
  hero: {
    badge: "Trusted across U.S. and Latin America",
    title_1: "Your home,",
    title_2: "spotless.",
    title_3: "Booked in 60 seconds.",
    subtitle: "Residential cleaning across the U.S. and Latin America. Online booking, secure payment, zero phone calls.",
    cta_primary: "Book your cleaning",
    cta_secondary: "How it works",
    rating_label: "5.0 rating · 230+ homes",
    instant_quote: "Instant quote",
    pro_badge: "Insured & vetted pros",
    availability_banner: "Appointments available 7 days a week — book in under 60 seconds",
  },
  quick_quote: {
    title: "Get your free quote in 60 seconds",
    placeholder: "Enter your ZIP code",
    go: "Go",
    microcopy: "Available 7 days a week — no credit card required",
    invalid: "Please enter a valid 5-digit ZIP code",
  },
  trust: {
    years: "15+ years of cleaning experience",
    insured: "Insured & LLC-registered",
    guarantee: "100% satisfaction guarantee",
    online: "Online booking · No phone calls",
  },
  how: {
    title: "How it works",
    subtitle: "From dirty to spotless in three easy steps.",
    video_eyebrow: "Watch how it works",
    video_caption: "Meet the Ever Clean Home team",
    step1_title: "Tell us about your home",
    step1_desc: "Answer a few quick questions about your space and what you need cleaned.",
    step2_title: "Pay securely online",
    step2_desc: "Get an instant quote. Pay with any credit or debit card via Stripe.",
    step3_title: "We come clean",
    step3_desc: "Our insured team shows up on the day you choose and leaves your home spotless.",
  },
  services: {
    title: "What we clean",
    subtitle: "Every room, every corner — we make it shine.",
    items: [
      { t: "Kitchens", d: "Counters, appliances, sinks, floors. Optional deep clean inside fridge & oven." },
      { t: "Bathrooms", d: "Tiles, glass, fixtures, sinks. Sanitized and streak-free." },
      { t: "Bedrooms & living rooms", d: "Dusting, vacuuming, mopping, surfaces. Hypoallergenic available." },
      { t: "Laundry", d: "Wash, dry, fold and put away. Tell us your preferences." },
      { t: "Windows", d: "Inside surfaces, frames and sills." },
      { t: "Move-in / Move-out", d: "End-of-lease deep cleans that get your deposit back." },
    ],
  },
  zones: { title: "Serving the Boston area", subtitle: "Active in Boston, Connecticut, Rhode Island and Providence.", coverage: "Coverage area" },
  pricing_strip: {
    eyebrow: "Pricing",
    starting_at: "Starting at",
    note: "Transparent quote, no hidden fees.",
    studio: "Studio",
    apt_1: "1 BR Apartment",
    apt_2: "2 BR Apartment",
    house_3: "3+ BR House",
    from: "from",
  },
  before_after: {
    chip: "The Ever Clean difference",
    title_1: "Drag the slider.",
    title_2: "See the difference.",
    body: "We don't surface-clean. We deep-clean every surface, corner and edge that other services skip. Your home, restored.",
    bullets: [
      "Eco-friendly products that don't irritate kids or pets",
      "Detailed inside-fridge, inside-oven and inside-cabinet cleaning",
      "Free re-clean within 24h if anything's missed",
    ],
    before: "BEFORE",
    after: "AFTER",
    rooms: ["Living room", "Kitchen", "Bedroom", "Bathroom", "Windows"],
  },
  testimonials: {
    title: "Loved by Boston homes",
    reply_label: "Our reply",
    items: [
      { name: "Sarah K.", city: "Boston, MA", quote: "Booked in literally 1 minute, paid online, done. They didn't miss a single corner." },
      { name: "Daniel R.", city: "Providence, RI", quote: "Reliable and detail-obsessed. The kitchen looked brand new after their deep clean." },
      { name: "Maria L.", city: "Cambridge, MA", quote: "Finally, a cleaning service that respects schedules. Highly recommend to busy families." },
    ],
  },
  faq: {
    title: "Frequently asked questions",
    see_all: "See all FAQs →",
    items: [
      { q: "How do I book?", a: "Click 'Book your cleaning' and answer a few quick questions about your home. You'll see the price update live and pay securely with Stripe." },
      { q: "What's included in a standard cleaning?", a: "Included in every cleaning — no extra charge:\n• Sweeping, vacuuming and mopping all floors\n• Cleaning and disinfecting bathrooms\n• Kitchen surfaces, sink and stovetop\n• Wiping down surfaces and general tidying\n• Taking out the trash\nThe options below are add-ons on top of this." },
      { q: "Are you insured?", a: "Yes. Ever Clean Home is fully insured and LLC-registered in Massachusetts." },
      { q: "What if I'm not happy with the service?", a: "We offer a 100% satisfaction guarantee. If something's not right, let us know within 24h and we'll re-clean it free of charge." },
      { q: "Do I have to be home?", a: "No. Many of our customers leave instructions in the 'Additional notes' field and we let ourselves in via the agreed access method." },
      { q: "Which areas do you cover?", a: "Boston (MA), Connecticut, Rhode Island and Providence (RI). More coming soon." },
      { q: "Can I reschedule?", a: "Yes — just reply to your confirmation email at least 24h in advance and we'll happily re-coordinate." },
      { q: "Do you bring supplies?", a: "Yes, we bring all eco-friendly supplies and professional equipment. Let us know if you have allergies or product preferences." },
      { q: "Do you offer recurring cleaning?", a: "Recurring plans are coming soon. For now, simply rebook us whenever you need a refresh." },
      { q: "What payment methods do you accept?", a: "All major credit and debit cards via Stripe. Your payment info never touches our servers." },
      { q: "How long does a cleaning take?", a: "Typically 2-4 hours depending on the size of your home and the services selected." },
    ],
  },
  final_cta: {
    title_1: "Less dirt.",
    title_2: "More shine.",
    body: "Book a cleaning in under 60 seconds. No phone calls. No back-and-forth.",
  },
  footer: {
    tagline: "Less Dirt More Shine",
    rights: "All rights reserved.",
    contact: "Contact",
    legal: "Legal",
    service_areas: "Service areas",
    terms: "Terms",
    privacy: "Privacy",
    sms: "SMS Program",
    book: "Book a cleaning",
    track: "Track booking",
    about: "About",
    admin: "Admin",
    work_with_us: "Work with us",
    description: "Trusted residential cleaning across the U.S. and Latin America.",
  },
  wizard: {
    step: "Step",
    of: "of",
    back: "Back",
    next: "Continue",
    finish: "Continue to payment",
    finish_coordination: "Submit request",
    creating: "Creating booking…",
    step1: { title: "Where are we cleaning?", subtitle: "Choose your area to get accurate pricing.", outside: "We don't cover your zone yet", country_label: "Country", coming_soon: "Coming soon", or_select_state: "Or select another state" },
    coord: {
      title: "We clean here too ✨",
      body: "Ever Clean Home is expanding fast. Complete your booking and our coordination team will find the right cleaner for {country}. We'll confirm your appointment and send a secure payment link within 24–48 hours — you won't be charged until we confirm.",
      bullets: [
        "Finish your booking now — same instant quote",
        "We'll match a vetted cleaner in your area",
        "No charge until we confirm your appointment",
      ],
    },
    other_state: {
      eyebrow: "Other state",
      title: "My state isn't listed yet",
      sub: "Continue anyway — we'll find a cleaner near you",
    },
    nocov: {
      title: "We're not yet in {country}",
      subtitle: "But we're growing! Drop your details and we'll let you know the moment we land in your city.",
      email: "Email",
      city: "City",
      city_ph: "Your city",
      zip: "ZIP / Postal code (optional)",
      notify: "Notify me",
      done_title: "Got it! 🎉",
      done_body: "We'll email you as soon as we arrive in your area.",
    },
    step2: {
      title: "What type of space is it?", subtitle: "Pick the option that best describes your place.",
      space_description_label: "What kind of space is it?",
      space_description_placeholder: "e.g. warehouse, empty office, post-construction, single room",
    },
    step3: { title: "How big is your home?", subtitle: "Drag the slider — a typical 2-bedroom apartment is ~900 sq ft.", unit: "sq ft" },
    step4: {
      title: "How many rooms?", title_other: "How many bathrooms?",
      subtitle: "We use this to estimate the time and team size.", bedrooms: "Bedrooms", bathrooms: "Bathrooms", half_bathrooms: "Half bathrooms",
    },
    step5: { title: "Any extras?", subtitle: "Pick everything that applies. You can always add notes later." },
    included: {
      title: "Included in every cleaning — no extra charge:",
      items: [
        "Sweeping, vacuuming and mopping all floors",
        "Cleaning and disinfecting bathrooms",
        "Kitchen surfaces, sink and stovetop",
        "Wiping down surfaces and general tidying",
        "Taking out the trash",
      ],
      closing: "The options below are add-ons on top of this.",
      toggle: "What's included?",
    },
    step6: {
      title: "Last step — your details",
      subtitle: "We'll send the confirmation to this email.",
      notes_label: "Anything we should know?",
      notes_placeholder: "Tell us anything we should know — pets, allergies, areas to focus on, access instructions, etc.",
      date_label: "Preferred date (optional)",
      time_label: "Preferred time",
      time_morning: "Morning (7 AM – 11 AM)",
      time_midday: "Midday (11 AM – 2 PM)",
      time_afternoon: "Afternoon (2 PM – 5 PM)",
      time_evening: "Evening (5 PM – 8 PM)",
      time_night: "Night (8 PM – 10 PM)",
      time_flexible: "Flexible — anytime",
      consent: "I agree to the Terms & Privacy Policy",
      sms_consent: "Text me updates about my booking. Ever Clean Home will send booking confirmations, a reminder the day before, and an alert when your cleaner is on the way. Message frequency varies. Message and data rates may apply. Reply STOP to unsubscribe or HELP for help. See our",
      privacy_policy_link: "Privacy Policy",
      full_name: "Full name",
      email: "Email",
      phone: "Phone",
      zip_code: "ZIP code",
      address_line1: "Address line 1",
      address_line2: "Address line 2",
      city: "City",
      state: "State / Province",
      state_placeholder: "e.g. Florida",
      address_line2_placeholder: "Apt 4B (optional)",
    },
    properties: { apartment: "Apartment", house: "House", studio: "Studio", condo: "Condo", other: "Other space", other_sub: "Warehouse, office, unit, room" },
    custom_quote: {
      message: "Spaces this size need a custom quote. Send us the details and we'll get back to you with a price.",
    },
    summary: {
      title: "Your quote",
      base: "Base price",
      base_commercial: "Base (commercial)",
      size: "Size",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      half_bath: "Half baths",
      tasks: "Extras",
      zone: "Zone fee",
      subtotal: "Subtotal",
      discount: "Discount",
      total: "Total",
      empty: "Pick a zone to get started",
      custom_quote_short: "Custom quote",
    },
    promo: {
      have_code: "Have a promo code?",
      label: "Promo code",
      applied: "Promo applied",
      off: "off",
      min_subtotal: "This code requires a minimum of {amount} subtotal. Add more services to unlock it.",
      invalid: "That code isn't valid or has expired.",
    },
    zip: {
      outside: "Heads up: this ZIP isn't in any active zone yet. We'll still try to serve you, but coverage may be limited.",
      mismatch: "This ZIP looks like it belongs to {zone}. Continue if you're sure, or go back to Step 1.",
      match: "ZIP confirmed in {zone}.",
    },
  },
  waitlist: {
    title: "Not in our zone yet?",
    subtitle: "Drop your email and ZIP — we'll notify you when we expand.",
    email: "Email",
    zip: "ZIP",
    city: "City (optional)",
    notify: "Notify me",
    done_title: "You're on the list.",
    done_body: "We'll email you the moment we start cleaning in your area.",
    error: "Something went wrong. Please try again.",
  },
  hosts: {
    nav: "For Airbnb hosts",
    hero_badge: "For Airbnb & short-term rental hosts",
    hero_title: "Run an Airbnb? Stop juggling cleanings.",
    hero_sub: "Connect your Airbnb calendar once. We clean between every guest, automatically.",
    hero_cta: "Get started — it's free to set up",
    how_title: "How it works",
    how_1_t: "Connect your listing calendar",
    how_1_d: "Paste your Airbnb iCal link — we show you exactly where to find it.",
    how_2_t: "Tell us how you like it cleaned",
    how_2_d: "Set your tasks, timing and any access notes once.",
    how_3_t: "We clean between every checkout",
    how_3_d: "Auto-scheduled turnovers. You never lift a finger.",
    get_title: "What you get",
    get_1: "Auto-scheduled cleaning the day of (or day after) every guest checkout",
    get_2: "Same trained team every time — consistency your guests will notice",
    get_3: "Hands-off operation — focus on growing your listings, not coordinating turnover",
    get_4: "Cancel or reschedule any cleaning from a one-click link in your email",
    get_5: "Connect as many listings as you run — all in one place",
    ical_title: "How to get your Airbnb iCal URL",
    ical_1: "Log in to Airbnb → Hosting → Calendar",
    ical_2: 'Click "Availability settings"',
    ical_3: 'Scroll to "Sync calendars" → "Export Calendar"',
    ical_4: "Copy the link Airbnb gives you (looks like https://www.airbnb.com/calendar/ical/…ics)",
    final_cta: "Connect your first listing",
    form_title: "Connect your listing",
    form_sub: "Takes 2 minutes. No subscription, no commitment.",
    sec_contact: "Your contact",
    sec_listing: "Listing details",
    sec_prefs: "Cleaning preferences",
    sec_calendar: "Connect calendar",
    sec_pricing: "Pricing",
    f_full_name: "Full name",
    f_email: "Email",
    f_phone: "Phone",
    f_nickname: "Listing nickname",
    f_nickname_ph: "Beacon Hill Studio",
    f_address: "Full address",
    f_city: "City",
    f_state: "State / Province",
    f_zip: "ZIP code",
    f_property: "Property type",
    f_sqft: "Square feet",
    f_bedrooms: "Bedrooms",
    f_bathrooms: "Bathrooms",
    f_half: "Half baths",
    f_tasks: "Tasks always included",
    f_time: "Preferred time",
    f_offset: "Cleaning happens",
    offset_0: "Same day as checkout",
    offset_1: "Next day",
    offset_2: "2 days after",
    f_notes: "Anything we should know?",
    f_notes_ph: "Pets, access codes, instructions for the cleaner…",
    f_ical: "Your Airbnb iCal URL",
    f_ical_help: "How to get this",
    test_cal: "Test calendar",
    testing: "Testing…",
    test_ok: "{n} upcoming checkout(s) found",
    test_none: "Connected, but no upcoming checkouts yet.",
    test_err: "Couldn't read that calendar — double-check the URL.",
    price_per: "Per-cleaning price",
    price_note: "You'll be charged per cleaning. No subscription, no commitment.",
    price_hint: "Add your listing details above to see your price.",
    submit: "Activate auto-cleaning",
    done_title: "You're all set! 🎉",
    done_body: "We connected your calendar and scheduled {n} upcoming cleaning(s). Check your email for the details.",
    add_another: "Connect another listing",
    back_home: "Back to home",
    manage_for: "Cleaning at",
    manage_on: "Scheduled for",
    manage_total: "Estimated price",
    manage_expired: "This link has expired.",
    manage_invalid: "This link is invalid or has already been used.",
    cancel_title: "Cancel this cleaning?",
    cancel_sub: "We won't show up for this turnover. You can always reconnect for future checkouts.",
    cancel_confirm: "Yes, cancel it",
    keep: "Keep it",
    cancel_done: "Cleaning cancelled",
    cancel_done_body: "Got it — we won't clean for this checkout.",
    resched_title: "Reschedule this cleaning",
    resched_sub: "Pick a new date that works better for this turnover.",
    resched_new: "New date",
    resched_submit: "Confirm new date",
    resched_done: "Cleaning rescheduled",
    resched_done_body: "Done — we've moved your cleaning to {date}.",
  },
  checkout: {
    title: "Review & pay",
    subtitle: "Powered by Stripe — your payment info is encrypted and never touches our servers.",
    pay_btn: "Pay {amount} securely",
    creating: "Redirecting to secure checkout...",
    back: "Back to booking",
    summary_title: "Booking summary",
    cancelled_toast: "Payment cancelled — you can retry below.",
    zone: "Zone",
    property: "Property",
    size: "Size",
    date: "Date",
    total: "Total",
    not_found: "Booking not found",
    start_over: "Start over",
    powered_by: "Powered by",
    encrypted: "your payment info is encrypted.",
    agreement_label: "I have read and agree to the",
    agreement_link: "Service Agreement",
    agreement_required: "Please accept the Service Agreement before paying.",
  },
  confirmation: {
    title: "You're all set!",
    subtitle: "We received your payment. A confirmation email is on its way.",
    booking_number: "Booking number",
    coordinate: "We'll contact you within 24 hours to coordinate the schedule.",
    book_another: "Book another",
    home: "Back to home",
    polling: "Confirming your payment…",
    failed: "Payment not confirmed yet. Please check your email — if you were charged, your booking is being processed.",
    print_receipt: "Print receipt",
    receipt_error: "Could not load the receipt. Please try again.",
    track: "Track booking",
  },
  coordination: {
    title: "We're on it ✨",
    body1: "We received your request. Our coordination team is finding the right cleaner for your area right now.",
    body2: "We'll get back to you within the next 24-48 hours with your confirmed appointment time and the payment link to secure your spot.",
    ref_label: "Booking reference",
    bullet1: "You haven't been charged yet",
    bullet2: "You'll receive everything by email at",
    bullet3: "Need to update anything? Reply to that email and we'll handle it.",
    book_another: "Book another",
    home: "Back to home",
  },
  landing: {
    airbnb_eyebrow: "For Airbnb hosts",
    airbnb_title: "Run an Airbnb? We clean between every guest, automatically.",
    airbnb_sub: "Connect your listing calendar once. Our team handles every turnover so you can focus on growing.",
    airbnb_cta: "Learn more about hosting",
    real_eyebrow: "Behind the shine",
    real_title: "Real cleanings, real homes",
    real_sub: "A peek at the everyday work our vetted pros do across thousands of homes.",
  },
  contact: {
    title: "Get in touch",
    subtitle: "Questions, partnership offers, or anything else — we'd love to hear from you.",
    name: "Your name",
    email: "Email",
    message: "Message",
    send: "Send message",
    sent: "Thanks — we'll get back to you shortly.",
    whatsapp_title: "Need an answer right now?",
    whatsapp_desc: "Chat with us on WhatsApp and we'll reply fast.",
    whatsapp_cta: "Chat on WhatsApp",
    or_form: "Or send us a message",
  },
  whatsapp: { chat: "WhatsApp" },
  tracking: {
    title: "Track your booking",
    subtitle: "Enter your booking number (in the confirmation email) to see live status.",
    placeholder: "EC-2026-00001",
    track_btn: "Track",
    not_found_title: "Booking not found",
    not_found_body: "Double-check the number on your confirmation email, or contact us if you need help.",
    booking_label: "Booking",
    greeting: "Hi, {name}",
    zone: "Zone",
    property: "Property",
    size: "Size",
    rooms: "Bedrooms / Baths",
    space_type: "Space type",
    date: "Date",
    area: "Area",
    total: "Total",
    activity: "Activity",
    print_receipt: "Print receipt",
    download_pdf: "Download PDF receipt",
    book_again: "Book again",
    help: "Need to reschedule or cancel? Reply to your confirmation email or message us on WhatsApp.",
    review_title: "Leave a review",
    review_q: "How was your experience?",
    review_placeholder: "Optional — what stood out? Anything we could improve?",
    review_submit: "Submit review",
    review_already: "Thanks — you've already submitted a review for this booking.",
    review_thanks: "Thank you for your review!",
    review_thanks_sub: "Once approved, it will help other Boston homes find us.",
    review_pick_rating: "Pick a rating first",
    review_error: "Could not submit review",
  },
  admin: {
    login_title: "Admin sign in",
    login_subtitle: "Manage bookings, pricing and zones.",
    email: "Email",
    password: "Password",
    sign_in: "Sign in",
    dashboard: "Dashboard",
    bookings: "Bookings",
    coordination: "Coordination",
    pricing: "Pricing",
    zones: "Zones",
    settings: "Settings",
    users: "Users",
    cleaners: "Cleaners",
    applications: "Applications",
    identity_checks: "Identity checks",
    promos: "Promos",
    reviews: "Reviews",
    waitlist: "Waitlist",
    hosts: "Hosts",
    audit_log: "Audit log",
    logout: "Logout",
  },
  common: {
    loading: "Loading…",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    yes: "Yes",
    no: "No",
    search: "Search",
  },
};

const es = {
  nav: { home: "Inicio", book: "Reservar", faq: "Preguntas", contact: "Contacto", admin: "Admin", about: "Nosotros", track: "Seguimiento" },
  hero: {
    badge: "Confiados en EE.UU. y Latinoamérica",
    title_1: "Tu casa,",
    title_2: "impecable.",
    title_3: "Reserva en 60 segundos.",
    subtitle: "Limpieza residencial en Estados Unidos y Latinoamérica. Reserva online, pago seguro, sin llamadas.",
    cta_primary: "Reserva tu limpieza",
    cta_secondary: "Cómo funciona",
    rating_label: "5.0 · 230+ hogares",
    instant_quote: "Cotización instantánea",
    pro_badge: "Personal asegurado y verificado",
    availability_banner: "Turnos disponibles los 7 días — reserva en menos de 60 segundos",
  },
  quick_quote: {
    title: "Obtén tu cotización gratis en 60 segundos",
    placeholder: "Ingresa tu código ZIP",
    go: "Ir",
    microcopy: "Disponible los 7 días — sin tarjeta de crédito",
    invalid: "Ingresa un código ZIP válido de 5 dígitos",
  },
  trust: {
    years: "15+ años de experiencia",
    insured: "Asegurada y registrada LLC",
    guarantee: "Garantía de satisfacción 100%",
    online: "Reserva online · Sin llamadas",
  },
  how: {
    title: "Cómo funciona",
    subtitle: "De sucio a impecable en tres pasos.",
    video_eyebrow: "Mira cómo funciona",
    video_caption: "Conoce al equipo de Ever Clean Home",
    step1_title: "Cuéntanos sobre tu casa",
    step1_desc: "Responde unas preguntas rápidas sobre tu espacio y lo que necesitas limpiar.",
    step2_title: "Pagas seguro online",
    step2_desc: "Recibes cotización instantánea y pagas con tarjeta vía Stripe.",
    step3_title: "Limpiamos",
    step3_desc: "Nuestro equipo asegurado va el día que eliges y deja tu casa impecable.",
  },
  services: {
    title: "Qué limpiamos",
    subtitle: "Cada ambiente, cada rincón — lo dejamos brillando.",
    items: [
      { t: "Cocinas", d: "Encimeras, electrodomésticos, fregaderos, pisos. Refrigerador y horno opcional." },
      { t: "Baños", d: "Azulejos, vidrios, griferías, fregaderos. Sanitizado." },
      { t: "Dormitorios y sala", d: "Limpieza de polvo, aspirado, trapeado." },
      { t: "Lavandería", d: "Lavar, secar, doblar y guardar." },
      { t: "Ventanas", d: "Interior, marcos y umbrales." },
      { t: "Entrada / Salida de inquilino", d: "Limpieza profunda fin de contrato." },
    ],
  },
  zones: { title: "Cubrimos el área de Boston", subtitle: "Activos en Boston, Connecticut, Rhode Island y Providence.", coverage: "Zona de cobertura" },
  pricing_strip: {
    eyebrow: "Precios",
    starting_at: "Desde",
    note: "Cotización transparente, sin sorpresas.",
    studio: "Studio",
    apt_1: "Depto 1 dorm",
    apt_2: "Apartamento 2 habitaciones",
    house_3: "Casa 3+ habitaciones",
    from: "desde",
  },
  before_after: {
    chip: "La diferencia Ever Clean",
    title_1: "Arrastra el slider.",
    title_2: "Mira la diferencia.",
    body: "No limpiamos por arriba. Limpiamos cada superficie, esquina y borde que otros servicios saltean. Tu casa, restaurada.",
    bullets: [
      "Productos eco-friendly que no irritan a chicos ni mascotas",
      "Limpieza detallada por dentro de refrigerador, horno y alacenas",
      "Re-limpieza gratis en las primeras 24h si algo quedó",
    ],
    before: "ANTES",
    after: "DESPUÉS",
    rooms: ["Sala", "Cocina", "Dormitorio", "Baño", "Ventanas"],
  },
  testimonials: {
    title: "Adorado por Boston",
    reply_label: "Nuestra respuesta",
    items: [
      { name: "Sarah K.", city: "Boston, MA", quote: "Reservé en 1 minuto, pagué online y listo. Ningún rincón quedó sin limpiar." },
      { name: "Daniel R.", city: "Providence, RI", quote: "Confiables y obsesivos del detalle. La cocina parecía nueva." },
      { name: "Maria L.", city: "Cambridge, MA", quote: "Por fin un servicio que respeta los horarios. Súper recomendado." },
    ],
  },
  faq: {
    title: "Preguntas frecuentes",
    see_all: "Ver todas las preguntas →",
    items: [
      { q: "¿Cómo reservo?", a: "Haz clic en 'Reserva tu limpieza' y responde unas preguntas. Vas a ver el precio actualizarse en vivo y pagas seguro con Stripe." },
      { q: "¿Qué incluye una limpieza estándar?", a: "Incluido en toda limpieza, sin costo adicional:\n• Barrer, aspirar y trapear todos los pisos\n• Limpiar y desinfectar los baños\n• Superficies de cocina, fregadero y estufa\n• Repasar superficies y ordenar en general\n• Sacar la basura\nLas opciones de abajo se suman a esto." },
      { q: "¿Están asegurados?", a: "Sí. Ever Clean Home está completamente asegurada y registrada LLC en Massachusetts." },
      { q: "¿Y si no quedo conforme?", a: "Tenemos garantía 100%. Si algo no está bien, avísanos en 24h y volvemos a limpiar gratis." },
      { q: "¿Tengo que estar en casa?", a: "No. Muchos clientes dejan instrucciones en 'Notas adicionales' y entramos con el método de acceso acordado." },
      { q: "¿Qué zonas cubren?", a: "Boston (MA), Connecticut, Rhode Island y Providence (RI). Pronto más zonas." },
      { q: "¿Puedo reprogramar?", a: "Sí — responde el email de confirmación con al menos 24h de antelación." },
      { q: "¿Traen los productos?", a: "Sí, traemos productos eco y equipos profesionales. Avísanos si tienes alergias." },
      { q: "¿Tienen plan recurrente?", a: "Próximamente. Por ahora, reserva cuando lo necesites." },
      { q: "¿Métodos de pago?", a: "Tarjetas de crédito y débito vía Stripe. Tus datos no pasan por nuestros servidores." },
      { q: "¿Cuánto dura una limpieza?", a: "Entre 2 y 4 horas según el tamaño y los servicios seleccionados." },
    ],
  },
  final_cta: {
    title_1: "Menos suciedad.",
    title_2: "Más brillo.",
    body: "Reserva una limpieza en menos de 60 segundos. Sin llamadas. Sin idas y vueltas.",
  },
  footer: {
    tagline: "Less Dirt More Shine",
    rights: "Todos los derechos reservados.",
    contact: "Contacto",
    legal: "Legal",
    service_areas: "Zonas de servicio",
    terms: "Términos",
    privacy: "Privacidad",
    sms: "Programa de SMS",
    book: "Reservar limpieza",
    track: "Seguimiento de reserva",
    about: "Nosotros",
    admin: "Admin",
    work_with_us: "Trabaja con nosotros",
    description: "Limpieza residencial de confianza en Estados Unidos y Latinoamérica.",
  },
  wizard: {
    step: "Paso",
    of: "de",
    back: "Atrás",
    next: "Continuar",
    finish: "Ir al pago",
    finish_coordination: "Enviar solicitud",
    creating: "Creando reserva…",
    step1: { title: "¿Dónde limpiamos?", subtitle: "Elige tu zona para una cotización precisa.", outside: "Todavía no cubrimos tu zona", country_label: "País", coming_soon: "Próximamente", or_select_state: "O elige otro estado" },
    coord: {
      title: "Aquí también limpiamos ✨",
      body: "Ever Clean Home está creciendo rápido. Completa tu reserva y nuestro equipo de coordinación buscará al limpiador ideal para {country}. Confirmaremos tu turno y te enviaremos un enlace de pago seguro dentro de 24–48 horas — no se te cobrará nada hasta confirmar.",
      bullets: [
        "Termina tu reserva ahora — misma cotización instantánea",
        "Asignamos un limpiador verificado en tu zona",
        "Sin cobro hasta confirmar tu turno",
      ],
    },
    other_state: {
      eyebrow: "Otro estado",
      title: "Mi estado todavía no está en la lista",
      sub: "Continúa igual — encontraremos un limpiador cerca de ti",
    },
    nocov: {
      title: "Todavía no llegamos a {country}",
      subtitle: "¡Pero estamos creciendo! Déjanos tus datos y te avisamos apenas lleguemos a tu ciudad.",
      email: "Email",
      city: "Ciudad",
      city_ph: "Tu ciudad",
      zip: "Código postal (opcional)",
      notify: "Avisarme",
      done_title: "¡Listo! 🎉",
      done_body: "Te escribimos apenas lleguemos a tu zona.",
    },
    step2: {
      title: "¿Qué tipo de espacio es?", subtitle: "Elige la opción que mejor describe tu lugar.",
      space_description_label: "¿Qué tipo de espacio es?",
      space_description_placeholder: "ej. almacén, oficina vacía, post-obra, un solo cuarto",
    },
    step3: { title: "¿Qué tamaño tiene?", subtitle: "Arrastra el slider — un apartamento de 2 habitaciones tiene unos 900 sq ft.", unit: "sq ft" },
    step4: {
      title: "¿Cuántos ambientes?", title_other: "¿Cuántos baños?",
      subtitle: "Usamos esto para estimar el tiempo y el equipo.", bedrooms: "Dormitorios", bathrooms: "Baños", half_bathrooms: "Toilettes",
    },
    step5: { title: "¿Algún extra?", subtitle: "Marca todo lo que aplique. Puedes agregar notas más adelante." },
    included: {
      title: "Incluido en toda limpieza, sin costo adicional:",
      items: [
        "Barrer, aspirar y trapear todos los pisos",
        "Limpiar y desinfectar los baños",
        "Superficies de cocina, fregadero y estufa",
        "Repasar superficies y ordenar en general",
        "Sacar la basura",
      ],
      closing: "Las opciones de abajo se suman a esto.",
      toggle: "¿Qué incluye?",
    },
    step6: {
      title: "Último paso — tus datos",
      subtitle: "Te enviamos la confirmación a este email.",
      notes_label: "¿Algo que debamos saber?",
      notes_placeholder: "Cuéntanos sobre mascotas, alergias, áreas específicas, instrucciones de acceso, etc.",
      date_label: "Fecha preferida (opcional)",
      time_label: "Horario preferido",
      time_morning: "Mañana (7 AM – 11 AM)",
      time_midday: "Mediodía (11 AM – 2 PM)",
      time_afternoon: "Tarde (2 PM – 5 PM)",
      time_evening: "Tarde-Noche (5 PM – 8 PM)",
      time_night: "Noche (8 PM – 10 PM)",
      time_flexible: "Flexible — cuando puedas",
      consent: "Acepto los Términos y Privacidad",
      sms_consent: "Quiero recibir mensajes de texto sobre mi reserva. Ever Clean Home enviará la confirmación de la reserva, un recordatorio el día anterior y un aviso cuando el limpiador esté en camino. La frecuencia de mensajes varía. Pueden aplicar cargos por mensajes y datos. Responde STOP para darte de baja o HELP para ayuda. Consulta nuestra",
      privacy_policy_link: "Política de Privacidad",
      full_name: "Nombre completo",
      email: "Email",
      phone: "Teléfono",
      zip_code: "Código postal (ZIP)",
      address_line1: "Dirección línea 1",
      address_line2: "Dirección línea 2",
      city: "Ciudad",
      state: "Estado / Provincia",
      state_placeholder: "ej. Florida",
      address_line2_placeholder: "Depto 4B (opcional)",
    },
    properties: { apartment: "Apartamento", house: "Casa", studio: "Studio", condo: "Condo", other: "Otro espacio", other_sub: "Almacén, oficina, local, cuarto" },
    custom_quote: {
      message: "Los espacios de este tamaño necesitan una cotización personalizada. Envíanos los datos y te responderemos con un precio.",
    },
    summary: {
      title: "Tu cotización",
      base: "Precio base",
      base_commercial: "Base (comercial)",
      size: "Tamaño",
      bedrooms: "Dormitorios",
      bathrooms: "Baños",
      half_bath: "Toilettes",
      tasks: "Extras",
      zone: "Cargo zona",
      subtotal: "Subtotal",
      discount: "Descuento",
      total: "Total",
      empty: "Elige una zona para empezar",
      custom_quote_short: "Cotización personalizada",
    },
    promo: {
      have_code: "¿Tienes un código promocional?",
      label: "Código promocional",
      applied: "Código aplicado",
      off: "de descuento",
      min_subtotal: "Este código requiere un mínimo de {amount} de subtotal. Suma más servicios para activarlo.",
      invalid: "El código no es válido o expiró.",
    },
    zip: {
      outside: "Atención: este ZIP no está en ninguna zona activa todavía. Igualmente intentaremos cubrirte, pero la disponibilidad puede ser limitada.",
      mismatch: "Este ZIP parece pertenecer a {zone}. Continúa si estás seguro o vuelve al Paso 1.",
      match: "ZIP confirmado en {zone}.",
    },
  },
  waitlist: {
    title: "¿Todavía no cubrimos tu zona?",
    subtitle: "Déjanos tu email y ZIP — te avisamos cuando lleguemos.",
    email: "Email",
    zip: "ZIP",
    city: "Ciudad (opcional)",
    notify: "Avisarme",
    done_title: "Quedaste en la lista.",
    done_body: "Te escribimos apenas empecemos a limpiar en tu área.",
    error: "Algo salió mal. Prueba de nuevo.",
  },
  hosts: {
    nav: "Para hosts de Airbnb",
    hero_badge: "Para hosts de Airbnb y alquileres temporarios",
    hero_title: "¿Tienes un Airbnb? Deja de malabarear limpiezas.",
    hero_sub: "Conecta el calendario de tu Airbnb una vez. Limpiamos entre cada huésped, automáticamente.",
    hero_cta: "Empezar — es gratis configurarlo",
    how_title: "Cómo funciona",
    how_1_t: "Conecta el calendario de tu listing",
    how_1_d: "Pega el link iCal de tu Airbnb — te mostramos dónde encontrarlo.",
    how_2_t: "Dinos cómo te gusta la limpieza",
    how_2_d: "Configura tareas, horario y notas de acceso una sola vez.",
    how_3_t: "Limpiamos entre cada check-out",
    how_3_d: "Turnos agendados solos. No tienes que mover un dedo.",
    get_title: "Qué obtienes",
    get_1: "Limpieza agendada automáticamente el día (o el día después) de cada check-out",
    get_2: "El mismo equipo capacitado siempre — una consistencia que tus huéspedes notan",
    get_3: "Operación sin manos — enfócate en crecer tus listings, no en coordinar turnos",
    get_4: "Cancela o reprograma cualquier limpieza con un link de un clic en tu email",
    get_5: "Conecta todos los listings que manejes — todo en un solo lugar",
    ical_title: "Cómo obtener tu URL iCal de Airbnb",
    ical_1: "Ingresa a Airbnb → Hosting → Calendario",
    ical_2: 'Haz clic en "Configuración de disponibilidad"',
    ical_3: 'Baja hasta "Sincronizar calendarios" → "Exportar calendario"',
    ical_4: "Copia el link que te da Airbnb (se ve como https://www.airbnb.com/calendar/ical/…ics)",
    final_cta: "Conectar mi primer listing",
    form_title: "Conecta tu listing",
    form_sub: "Toma 2 minutos. Sin suscripción, sin compromiso.",
    sec_contact: "Tu contacto",
    sec_listing: "Datos del listing",
    sec_prefs: "Preferencias de limpieza",
    sec_calendar: "Conectar calendario",
    sec_pricing: "Precio",
    f_full_name: "Nombre completo",
    f_email: "Email",
    f_phone: "Teléfono",
    f_nickname: "Apodo del listing",
    f_nickname_ph: "Studio Beacon Hill",
    f_address: "Dirección completa",
    f_city: "Ciudad",
    f_state: "Estado / Provincia",
    f_zip: "Código postal",
    f_property: "Tipo de propiedad",
    f_sqft: "Pies cuadrados",
    f_bedrooms: "Dormitorios",
    f_bathrooms: "Baños",
    f_half: "Toilettes",
    f_tasks: "Tareas siempre incluidas",
    f_time: "Horario preferido",
    f_offset: "La limpieza ocurre",
    offset_0: "El mismo día del check-out",
    offset_1: "Al día siguiente",
    offset_2: "2 días después",
    f_notes: "¿Algo que debamos saber?",
    f_notes_ph: "Mascotas, códigos de acceso, instrucciones para el limpiador…",
    f_ical: "Tu URL iCal de Airbnb",
    f_ical_help: "Cómo conseguirla",
    test_cal: "Probar calendario",
    testing: "Probando…",
    test_ok: "{n} check-out(s) próximos encontrados",
    test_none: "Conectado, pero todavía no hay check-outs próximos.",
    test_err: "No pudimos leer ese calendario — revisa la URL.",
    price_per: "Precio por limpieza",
    price_note: "Se cobra por limpieza. Sin suscripción, sin compromiso.",
    price_hint: "Completa los datos del listing para ver tu precio.",
    submit: "Activar limpieza automática",
    done_title: "¡Todo listo! 🎉",
    done_body: "Conectamos tu calendario y agendamos {n} limpieza(s) próxima(s). Revisa tu email para los detalles.",
    add_another: "Conectar otro listing",
    back_home: "Volver al inicio",
    manage_for: "Limpieza en",
    manage_on: "Agendada para",
    manage_total: "Precio estimado",
    manage_expired: "Este link expiró.",
    manage_invalid: "Este link es inválido o ya fue usado.",
    cancel_title: "¿Cancelar esta limpieza?",
    cancel_sub: "No iremos a este turno. Siempre puedes reconectar para futuros check-outs.",
    cancel_confirm: "Sí, cancelar",
    keep: "Mantenerla",
    cancel_done: "Limpieza cancelada",
    cancel_done_body: "Listo — no limpiaremos para este check-out.",
    resched_title: "Reprogramar esta limpieza",
    resched_sub: "Elige una nueva fecha que funcione mejor para este turno.",
    resched_new: "Nueva fecha",
    resched_submit: "Confirmar nueva fecha",
    resched_done: "Limpieza reprogramada",
    resched_done_body: "Listo — movimos tu limpieza al {date}.",
  },
  checkout: {
    title: "Revisar y pagar",
    subtitle: "Powered by Stripe — tu información de pago está encriptada y nunca pasa por nuestros servidores.",
    pay_btn: "Pagar {amount} seguro",
    creating: "Redirigiendo al pago seguro...",
    back: "Volver a la reserva",
    summary_title: "Resumen de reserva",
    cancelled_toast: "Pago cancelado — puedes reintentarlo abajo.",
    zone: "Zona",
    property: "Vivienda",
    size: "Tamaño",
    date: "Fecha",
    total: "Total",
    not_found: "Reserva no encontrada",
    start_over: "Empezar de nuevo",
    powered_by: "Powered by",
    encrypted: "tu información de pago está encriptada.",
    agreement_label: "He leído y acepto el",
    agreement_link: "Acuerdo de Servicio",
    agreement_required: "Por favor acepta el Acuerdo de Servicio antes de pagar.",
  },
  confirmation: {
    title: "¡Todo listo!",
    subtitle: "Recibimos tu pago. El email de confirmación está en camino.",
    booking_number: "Número de reserva",
    coordinate: "Te contactaremos en menos de 24h para coordinar.",
    book_another: "Reservar otra",
    home: "Volver al inicio",
    polling: "Confirmando tu pago…",
    failed: "Pago no confirmado aún. Revisa tu email — si te cobraron, tu reserva se está procesando.",
    print_receipt: "Imprimir recibo",
    receipt_error: "No pudimos cargar el recibo. Intenta de nuevo.",
    track: "Seguir reserva",
  },
  coordination: {
    title: "¡Estamos en eso! ✨",
    body1: "Recibimos tu solicitud. Nuestro equipo de coordinación está buscando al limpiador ideal para tu zona en este momento.",
    body2: "Te contactaremos dentro de las próximas 24-48 horas con el horario confirmado y el enlace de pago para reservar tu lugar.",
    ref_label: "Referencia de reserva",
    bullet1: "Todavía no se te ha cobrado nada",
    bullet2: "Recibirás todo por email en",
    bullet3: "¿Necesitas cambiar algo? Responde ese email y nos encargamos.",
    book_another: "Reservar otra",
    home: "Volver al inicio",
  },
  landing: {
    airbnb_eyebrow: "Para hosts de Airbnb",
    airbnb_title: "¿Tienes un Airbnb? Limpiamos entre cada huésped, automáticamente.",
    airbnb_sub: "Conecta el calendario de tu listing una vez. Nuestro equipo se encarga de cada turno para que tú te enfoques en crecer.",
    airbnb_cta: "Conoce más sobre hosting",
    real_eyebrow: "Detrás del brillo",
    real_title: "Limpiezas reales, hogares reales",
    real_sub: "Un vistazo al trabajo diario que hacen nuestros profesionales verificados en miles de hogares.",
  },
  contact: {
    title: "Contáctanos",
    subtitle: "Preguntas, alianzas o cualquier consulta — escríbenos.",
    name: "Nombre",
    email: "Email",
    message: "Mensaje",
    send: "Enviar mensaje",
    sent: "Gracias — te contactamos en breve.",
    whatsapp_title: "¿Necesitas una respuesta ya?",
    whatsapp_desc: "Chatea con nosotros por WhatsApp y te respondemos rápido.",
    whatsapp_cta: "Chatear por WhatsApp",
    or_form: "O envíanos un mensaje",
  },
  whatsapp: { chat: "WhatsApp" },
  tracking: {
    title: "Sigue tu reserva",
    subtitle: "Ingresa el número de reserva (está en el email de confirmación) para ver el estado en vivo.",
    placeholder: "EC-2026-00001",
    track_btn: "Seguir",
    not_found_title: "Reserva no encontrada",
    not_found_body: "Revisa el número en el email de confirmación, o escríbenos si necesitas ayuda.",
    booking_label: "Reserva",
    greeting: "Hola, {name}",
    zone: "Zona",
    property: "Vivienda",
    size: "Tamaño",
    rooms: "Habitaciones / Baños",
    space_type: "Tipo de espacio",
    date: "Fecha",
    area: "Área",
    total: "Total",
    activity: "Actividad",
    print_receipt: "Imprimir recibo",
    download_pdf: "Descargar recibo en PDF",
    book_again: "Reservar otra vez",
    help: "¿Necesitas reprogramar o cancelar? Responde el email de confirmación o escríbenos por WhatsApp.",
    review_title: "Deja una reseña",
    review_q: "¿Cómo fue tu experiencia?",
    review_placeholder: "Opcional — ¿qué destacó? ¿algo que podamos mejorar?",
    review_submit: "Enviar reseña",
    review_already: "Gracias — ya enviaste una reseña para esta reserva.",
    review_thanks: "¡Gracias por tu reseña!",
    review_thanks_sub: "Una vez aprobada, ayuda a que más hogares de Boston nos encuentren.",
    review_pick_rating: "Elige un puntaje primero",
    review_error: "No pudimos enviar la reseña",
  },
  admin: {
    login_title: "Ingreso de administrador",
    login_subtitle: "Gestiona reservas, precios y zonas.",
    email: "Email",
    password: "Contraseña",
    sign_in: "Ingresar",
    dashboard: "Dashboard",
    bookings: "Reservas",
    coordination: "Coordinación",
    pricing: "Precios",
    zones: "Zonas",
    settings: "Ajustes",
    users: "Usuarios",
    cleaners: "Limpiadores",
    applications: "Aplicaciones",
    identity_checks: "Verificación de identidad",
    promos: "Promos",
    reviews: "Reseñas",
    waitlist: "Lista de espera",
    hosts: "Hosts",
    audit_log: "Auditoría",
    logout: "Salir",
  },
  common: {
    loading: "Cargando…",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    create: "Crear",
    yes: "Sí",
    no: "No",
    search: "Buscar",
  },
};

export const dictionaries = { en, es };
